<template>
	<div id="app" class="app-main" >
		<Header v-if="($route.fullPath == '/' && !$route.fullPath.indexOf('?') == -1) ? false :true " />
		<router-view v-if="isRouterAlive3"></router-view>
		<Footer  v-if="isRouterAlive2"/>
		<!-- <footerNew></footerNew> -->
		<!-- <div class="copyright_icon" @click="copyright_registration()" v-show="is_show=='2'">
			<img src="./assets/copyright.png" />
		</div> -->
		<div class="meiqia_box">
			<div :class="(meiqia_open ? 'active meiqia_left' : 'meiqia_left')" @click="toggleMeiqia()">在线咨询</div>
			<div v-if="meiqia_open" class="meiqia_box_main">
				<h3 class="meiqia_box_title">在线客服</h3>
				<ul class="meiqia_box_group">
					<li class="meiqia_box_item" @click="openChats">存证/登记咨询</li>
					<li class="meiqia_box_item" @click="openChats">取证咨询</li>
					<li class="meiqia_box_item" @click="openChats">监测咨询</li>
					<li class="meiqia_box_item" @click="openChats">法律咨询</li>
					<li class="meiqia_box_item" @click="openChats">会员服务</li>
					<li class="meiqia_box_item" @click="openChats">解决方案定制</li>
				</ul>
				<div class="return_top" :style="!scrollBtnFlag ? 'visibility: hidden' : ''">
					<div class="return_top_btn" @click="backTop">返回顶部</div>
				</div>
				<ul class="meiqia_box_text">
					<li class="meiqia_box_text_item">全国免费服务热线</li>
					<li class="meiqia_box_text_item">17316071137，17316071136</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
	import Header from '@/views/main-components/header';
	import Footer from '@/views/main-components/footerNew';
	import {
		userInfo
	} from "@/api/index";
	import util from '@/libs/util';
	import Cookies from "js-cookie";
	import {
		getStore
	} from "./libs/storage";


	export default {
		components: {
			Header,
			Footer,
		},
		provide() {
			return {
				reload: this.reload
			}
		},
		data() {
			return {
				isRouterAlive2:false,
				header_show: true,
				footer_show: true,
				meiqia_state: false,
				meiqia_open: false,
				scrollBtnFlag: false,
				isRouterAlive: false,
				isRouterAlive3:false
			};
		},
		watch: {
			// 监听地址栏变化
			$route(to, from) {
				console.log(to)
				console.log(from)
			}
		} ,
		created() {
			this.otherLogin();
			// this.uCenterLogin();
		},
		mounted() {
			//友盟-站长统计
			const script1 = document.createElement('script');
			script1.src = 'https://s4.cnzz.com/z_stat.php?id=1261139025&show=pic1';
			script1.language = 'JavaScript';
			document.body.appendChild(script1);
			const script2 = document.createElement('script');
			script2.src = 'https://c.cnzz.com/core.php?web_id=1261139025&show=pic1&t=z';
			script2.language = 'JavaScript';
			document.body.appendChild(script2);


			this.$nextTick(function() {
			});
			window.addEventListener('scroll', this.scrollToTop)
			window.onload=()=>{
				// if(this.$route.fullPath == '/'){
				// 	this.isRouterAlive=false
				// }else{
				// 	this.isRouterAlive=true
				// }
				this.isRouterAlive2=true;
				this.isRouterAlive3=true
				
			}
		},
		destroyed() {
			window.removeEventListener('scroll', this.scrollToTop)
		},
		beforeDestroy() {},
		watch: {
			'$route'() {
				
				if (window._czc) {
					let location = window.location
					let contentUrl = location.pathname + location.hash
					let refererUrl = '/'
					window._czc.push(['_trackPageview', contentUrl, refererUrl])
				}
				

			},
			// $route: function(r) {
			// 	console.log(r, 666666666666)
			// 	// this.is_show=r.path !== '/huodong/zhishichanquanri.html';
			// 	if (r.path == '/huodong/zhishichanquanri.html') {
			// 		this.is_show = false

			// 	}
			// }
		},
		
		methods: {

			reload() {
				this.isRouterAlive = false
				this.$nextTick(function() {
					this.isRouterAlive = true
				})
			},

			/****************************接收token部分****************************/
			otherLogin() {
				let accessToken = util.getQueryString('data');

				if (accessToken && accessToken != '') {
					this.setStore("accessToken", accessToken);

					// 获取用户信息
					userInfo().then(res => {
						console.log("?????????????????????", res)
						if (res.code == 200) {
							// 避免超过大小限制
							if (this.saveLogin) {
								// 保存7天
								Cookies.set("userInfo", JSON.stringify(res.result), {
									expires: 7
								});
							} else {
								Cookies.set("userInfo", JSON.stringify(res.result));
							}
							this.setStore("userInfo", res.result);
							let photo = res.result.photo ? res.result.photo : ''
							this.$emit('childFn', photo);
							this.$store.commit("setAvatarPath", photo);
							// 加载菜单
							util.initRouter(this);
							this.$router.push({
								name: "home_index",
								// query:{
								//     t:Date.now(),
								// },
							});
							// this.closeLoginDialog()
						} else {
							this.loading = false;
						}
					});
				}
				

			},

			/****************************ucenter登录****************************/
			uCenterLogin() {
				let accessToken = getStore('accessToken');
				console.log(accessToken);
				if (!accessToken || accessToken == '') {

					if (Cookies.get('accessToken') && Cookies.get('accessToken') != '') {
						accessToken = Cookies.get('accessToken');
						this.setStore("accessToken", accessToken);


						// 获取用户信息
						userInfo().then(res => {
							console.log("?????????????????????", res)
							if (res.code == 200) {
								// 避免超过大小限制
								if (this.saveLogin) {
									// 保存7天
									Cookies.set("userInfo", JSON.stringify(res.result), {
										expires: 7
									});
								} else {
									Cookies.set("userInfo", JSON.stringify(res.result));
								}
								this.setStore("userInfo", res.result);
								let photo = res.result.photo ? res.result.photo : '';
								this.$emit('childFn', photo);
								this.$store.commit("setAvatarPath", photo);
								// 加载菜单
								util.initRouter(this);
								this.reload();

							} else {
								this.loading = false;
							}
						});
					}
				}
			},

			/****************************头部、尾部显示部分****************************/
			//是否显示头部
			header: function(bool) {
				this.header_show = bool;
			},

			//是否显示底部
			footer: function(bool) {
				this.footer_show = bool;
			},


			/****************************美洽部分****************************/
			//关闭美洽浮窗
			toggleMeiqia() {


				console.log("美洽初始化" + this.meiqia_state);
				if (!this.meiqia_state) { //判断美洽是否成功初始化

					console.log("美洽开始初始化" + new Date().getTime());
					(function(m, ei, q, i, a, j, s) {
						m[i] = m[i] || function() {
							(m[i].a = m[i].a || []).push(arguments)
						};
						j = ei.createElement(q),
							s = ei.getElementsByTagName(q)[0];
						j.async = false;
						j.charset = 'UTF-8';
						j.src = '//static.meiqia.com/dist/meiqia.js';
						s.parentNode.insertBefore(j, s);
					})(window, document, 'script', '_MEIQIA');

					_MEIQIA('entId', '6351b02e1b6975b5b7bb282762244a9f');
					//隐藏美洽客服按钮
					_MEIQIA('withoutBtn');
					// 初始化成功时的回调
					_MEIQIA('allSet', this.meiqiaCallBack);
					//创建美洽
					_MEIQIA('init');
					console.log("美洽初始化结束" + new Date().getTime());
				}
				this.meiqia_open = !this.meiqia_open;
			},

			//打开美洽聊天
			openChats() {

				if (this.meiqia_state) {
					_MEIQIA('showPanel');
				} else {

					console.log("美洽开始初始化" + new Date().getTime());
					(function(m, ei, q, i, a, j, s) {
						m[i] = m[i] || function() {
							(m[i].a = m[i].a || []).push(arguments)
						};
						j = ei.createElement(q),
							s = ei.getElementsByTagName(q)[0];
						j.async = false;
						j.charset = 'UTF-8';
						j.src = '//static.meiqia.com/dist/meiqia.js';
						s.parentNode.insertBefore(j, s);
					})(window, document, 'script', '_MEIQIA');

					_MEIQIA('manualInit');
					_MEIQIA('entId', '6351b02e1b6975b5b7bb282762244a9f');
					//隐藏美洽客服按钮
					_MEIQIA('withoutBtn');
					// 初始化成功时的回调
					_MEIQIA('allSet', this.meiqiaCallBack);
					//创建美洽
					_MEIQIA('init');
					console.log("美洽初始化结束" + new Date().getTime());
					_MEIQIA('showPanel');
				}


			},

			// 点击图片回到顶部方法，加计时器是为了过渡顺滑
			backTop() {
				let that = this;
				let timer = setInterval(() => {
					let ispeed = Math.floor(-that.scrollTop / 5);
					document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed;
					if (that.scrollTop === 0) {
						clearInterval(timer)
					}
				}, 16)
			},

			// 为了计算距离顶部的高度，当高度大于200显示回顶部图标，小于200则隐藏
			scrollToTop() {
				let that = this;
				let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
				that.scrollTop = scrollTop;
				if (that.scrollTop > 200) {
					that.scrollBtnFlag = true
				} else {
					that.scrollBtnFlag = false
				}
			},

			//美洽初始化成功回调
			meiqiaCallBack() {
				console.log("初始化回调成功" + new Date().getTime());
				this.meiqia_state = true;
			}


		}

	};
</script>

<style lang="less">
/** index.css **/
	@font-face {
		font-family: "sourcehansans"; /* 这个名字可以自己定义 */
		src: url("./fonts/sourcehansans.eot"); /* IE9 Compat Modes */ /*这里以及下面的src后面的地址填的都是自己本地的相对地址*/
		src: url("./fonts/sourcehansans.eot?#iefix") format("embedded-opentype"),
			/* IE6-IE8 */ url("./fonts/sourcehansans.woff") format("woff"),
			/* Modern Browsers */ url("./fonts/sourcehansans.ttf") format("truetype"),
			/* Safari, Android, iOS */ url("./fonts/sourcehansans.svg#YourWebFontName")
			format("svg"); /* Legacy iOS */
		font-weight: bold;
		font-style: normal;
	}
	html,
	body {
		width: 100%;
		height: 100%;
		background: #fff;
		font-family: "sourcehansans";
		/* overflow: hidden; */
	}

	.app-main {
		width: 100%;
		height: 100%;
	}

	.br button {
		margin-right: 5px;
	}

	.operation button {
		margin-right: 5px;
	}

	.ivu-btn-text:focus {
		box-shadow: none !important;
	}

	.copyright_icon {

		position: fixed;
		right: 16px;
		// top: 728px;
		z-index: 999;
		width: 150px;
		height: 140px;
	}

	.meiqia_box {
		right: 0;
		top: 50%;
		position: fixed;
		overflow: hidden;
		margin-top: -200px;
		z-index: 999;


		.meiqia_left {
			width: 28px;
			height: 130px;
			background: rgba(254, 216, 0, 1);
			border-radius: 3px 0 0 3px;
			text-align: center;
			color: #05050C;
			font-size: 13px;
			font-weight: 500;
			margin-top: 140px;
			padding: 25px 7px 0 8px;
			box-sizing: border-box;
			line-height: 1.2;
			cursor: pointer;
			float: left;

			&:after {
				content: '';
				width: 12px;
				height: 12px;
				display: inline-block;
				margin-top: 6px;
				background: url(../src/assets/meiqia_left.png) no-repeat left center;
				background-size: 100% 100%;
			}

			&.active:after {
				content: '';
				width: 12px;
				height: 12px;
				display: inline-block;
				margin-top: 6px;
				background: url(../src/assets/meiqia_right.png) no-repeat left center;
				background-size: 100% 100%;
			}

		}

		.meiqia_box_main {
			padding: 22px 12px;
			box-sizing: border-box;
			width: 138px;
			background: #05050C;
			border-radius: 4px 0 0 4px;
			text-align: center;
			float: left;

			.meiqia_box_title {
				font-weight: 500;
				font-size: 18px;
				color: #FED800;
			}

			.meiqia_box_group {
				list-style: none;
				padding-top: 16px;

				.meiqia_box_item {
					width: 114px;
					height: 32px;
					line-height: 32px;
					text-align: center;
					border-radius: 3px;
					border: 1px solid rgba(254, 216, 0, 1);
					color: #FED800;
					margin-bottom: 10px;
					cursor: pointer;
				}
			}

			.return_top {
				padding-top: 34px;

				.return_top_btn {
					width: 100%;
					height: 32px;
					line-height: 32px;
					background: #FED800;
					border-radius: 3px;
					color: #05050C;
					font-size: 14px;
					cursor: pointer;

					&:after {
						content: '';
						padding-left: 16px;
						height: 14px;
						background: url(./assets/meiqia_back.png) no-repeat right top;
						background-size: 14px 14px;

					}
				}
			}

			.meiqia_box_text {
				list-style: none;
				color: #FED800;
				font-size: 13px;

				.meiqia_box_text_item {
					padding-top: 9px;
					line-height: 1;
				}

			}
		}

	}

	/*.multiple_select_transfer {*/
	/*    max-width: 502px;*/

	/*    .ivu-select-item {*/
	/*        word-break: break-all;*/
	/*        white-space: normal;*/
	/*    }*/

	/*    .ivu-select-not-found {*/
	/*        font-size: 12px;*/
	/*        color: rgb(255, 0, 0);*/
	/*    }*/

	/*}*/
</style>
